<template>
  <div >
    <apexcharts 
    height="320" :options="chartOptions" 
    :series="series"></apexcharts>
  </div>
</template>

<script>
/* eslint-disable */

import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import moment, { now } from 'moment'
import { mapState } from 'vuex' 
import VueApexCharts from 'vue-apexcharts'
  export default {
    name: 'Chart',

    components: {
      apexcharts: VueApexCharts,
    },

    data: function() {
      return {
      
        
        chartOptions: {
          chart: {
            id: 'basic-bar',
            type: 'bar',
            height: 350,
           
            foreColor:"black",
            toolbar: {
              show: false
            },
          },
          
          dataLabels: {
            enabled: true,
          },

          plotOptions: {            
            bar: {
              
              horizontal: false,
              dataLabels: {
              
              },
              
              stroke: {
                    
                width: 1,
                colors: ['#fff']
                
              },
          
              legend: {
                position: 'top',
                horizontalAlign: 'left',
                offsetX: 40
              }          
          },        
            
          },
          
        
          xaxis: {
              categories: [2023, 2022,2021,2020,2019],
             
          },
          
          grid: {
      xaxis: {
        lines: {
          show: false
        }
      }
    }

  },
      series: [{
          name: 'RA',
          data: [144, 155, 141, 137, 135]
        }, {
          name: 'S.O.S',
          data: [153, 132, 133, 152, 145  ]
        }, {
          name: 'REC NORMAL',
          data: [112, 117, 111, 119, 118 ]
        }, {
        name: 'REC ANORMAL',
        data: [119, 117, 115, 118, 116 ]
      },],


      }
      
      
    },
        methods: {
     

      temporizador() {        
      this.handle = setInterval(() =>{
        this.barra_inicial = this.barra_inicial + 1000
        if(this.barra_inicial >= this.barra_limite){
          this.barra_inicial = 0
          this.loadSacSolicitacoes()
        }
      },1000)
      },

        loadEmpresas() {
          const url = `${baseApiUrl}/manutencao/rfi/empresa`
          axios.get(url).then(res => {
            this.empresas = res.data.map(empresa => {              
              return { id_empresa: empresa.id_empresa, empresa: empresa.nomeempresarial }
            })
          })
        },  
      
        loadGaragens() {
          const url = `${baseApiUrl}/manutencao/rfi/garagem`
          axios.get(url).then(res => {
            this.filiais = res.data.map(filial => {              
              return { id_filial_erp: filial.id_filial_erp, filial: filial.filial }
        //      return { ... fil, value: fil.id_filial_erp, filial: fil.filial }
            })
          })
        },        

        loadStatus() {
                      let params = {    
                "id_grupo": `${this.user.id_grupo}`,                                            
                "id_empresa": `${this.user.id_empresa}`,   
                 "psg": this.user.psg // Adiciona o 'psg' nos parâmetros                                                  
            };
          const url = `${baseApiUrl}/sac/status`
          axios.get(url,{params}).then(res => {
            this.statuss = res.data.map(sta => {              
               return { ... sta, value: sta.id_status, status: sta.status }
            })
          })
        },

        

        loadPermissao() {
            let params = {    
                "id_grupo": `${this.user.id_grupo}`,
                         "psg": this.user.psg // Adiciona o 'psg' nos parâmetros                                                     
            };

          const url = `${baseApiUrl}/sac/permissao`
          axios.post(url,{params}).then(res => {
            this.permissoes = res.data.map(permissao => {              
               return { ... permissao, id_area: permissao.id_area}
            })
            this.loadSacSolicitacoes()
            
          })
        },

        loadSacSolicitacoes() {
            let corpo = {    
                "id_empresa": `${[this.value_empresa.map(e=> e.id_empresa_erp)]}`,                
                "id_filial": `${[this.value_filial.map(a => a.id_filial_erp)]}`,                
                "id_status": `${[this.value_status.map(r => r.id_status)]}`,
                "id_area": `${[this.permissoes.map(p => p.id_area)]}`,               
            };
 
            const url = `${baseApiUrl}/sac/solicitacoes`            
            axios.post(url,corpo).then(res => {                                
                this.carregando = false;
                this.sacsolicitacoes = res.data.map(sacsolicitacao => {
                            return {                              
                              id_solicitacao: sacsolicitacao.id_solicitacao, 
                              id_empresa: sacsolicitacao.id_empresa, 
                              id_filial: sacsolicitacao.id_filial,
                              dt_abertura: sacsolicitacao.dt_abertura,                              
                              dt_inclusao: sacsolicitacao.dt_inclusao, 
                              dt_cadastro: sacsolicitacao.dt_cadastro,
                              area: sacsolicitacao.area,
                              modulo: sacsolicitacao.modulo,
                              id_funcionario_solicitante: sacsolicitacao.id_funcionario_solicitante,
                              re_solicitante: sacsolicitacao.re_solicitante,
                              funcao_solicitante: sacsolicitacao.funcao_solicitante,
                              justificativa: sacsolicitacao.justificativa,
                              id_status: sacsolicitacao.id_status, 
                              status: sacsolicitacao.status, 
                              id_funcionario_analise: sacsolicitacao.id_funcionario_analise,
                              re_analisado: sacsolicitacao.re_analisado,
                              dt_analise: sacsolicitacao.dt_analise,
                              id_funcionario_finalizada: sacsolicitacao.id_funcionario_finalizada,
                              re_finalizado: sacsolicitacao.re_finalizado,
                              dt_finalizada: sacsolicitacao.dt_finalizada,
                              parecer: sacsolicitacao.parecer,
                              id_leitura: sacsolicitacao.id_leitura,
                              leitura: sacsolicitacao.leitura,
                              foto_url: sacsolicitacao.foto_url,
                              nome: sacsolicitacao.nome,
                              tempo: sacsolicitacao.tempo,                            
                              pedido_ferias: sacsolicitacao.pedido_ferias                             
                            }              
                                                })                          
                                                
                        })                             
        },

        
        loadPedidoFerias() {
            let corpo = {                    
                "id_empresa": `${this.user.id_empresa}`,               
            };
 
            const url = `${baseApiUrl}/sac/ferias`            
            axios.post(url,corpo).then(res => {                                
                this.carregando = false;
                this.pedidoferias = res.data.map(pedidoferia => {
                            return {                              
                              id_empresa: pedidoferia.id_empresa, 
                              id_empresa_erp: pedidoferia.id_empresa_erp, 
                              id_filial: pedidoferia.id_filial,
                              id_solicitacao: pedidoferia.id_solicitacao,                              
                              re_solicitante: pedidoferia.re_solicitante, 
                              pedido_ferias: pedidoferia.pedido_ferias,
                              dt_solicitacao: pedidoferia.dt_solicitacao,
                              dt_finalizada: pedidoferia.dt_finalizada                     
                            }              
                })                                                                          
                this.gerarPlanilha()
            })                             
        },

               
        loadSacSolicitacoesTratativas() {                
            let corpo = {    
                "id_solicitacao": `${[this.sacsolicitacao.id_solicitacao]}`,                                
            };
 
            const url = `${baseApiUrl}/sac/solicitacoes/id`            
            axios.post(url,corpo).then(res => {                                
                this.carregando = false;
                this.sacsolicitacoestratativa = res.data.map(sacT => {
                            return {                              
                              id_solicitacao: sacT.id_solicitacao, 
                              dt_resposta: sacT.dt_resposta, 
                              id_respondido: sacT.id_respondido,
                              respondido: sacT.respondido,                              
                              registro: sacT.registro, 
                              justificativa: sacT.justificativa,
                              id_status_leitura: sacT.id_status_leitura,
                              status: sacT.status                            
                            }              
                                                })                          
                                                
            })            
        }, 

        loadCarregaSac(sacsolicitacao){
            this.sacsolicitacao = { ...sacsolicitacao }
        },
        loadCarregaSacT(sacsolicitacoestratativa){
            this.sacsolicitacoestratativa = { ...sacsolicitacoestratativa }
        },

        postSac() {                        
        let corpo = { 
                "id_funcionario": `${this.user.id_funcionario}`,
                "parecer": `${this.sacsolicitacao.parecer}`,
                "id_solicitacao": `${this.sacsolicitacao.id_solicitacao}`,
                "id_status": `${this.sacsolicitacao.id_status}`,                
                "status": `${[this.statuss.filter(a => a.id_status == this.sacsolicitacao.id_status).map(a => a.status)]}`        };

        const url = `${baseApiUrl}/sac/solicitacoes/save`   

            axios.post(url,corpo).then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.loadSacSolicitacoes()
                    //this.reset() limpar os objetos valores
                })
                .catch(showError)
        },

        postSacTratativa() {                        
          let corpo = { 
               "id_solicitacao": `${this.sacsolicitacao.id_solicitacao}`,
                "id_funcionario_resposta": `${this.user.id_funcionario}`,
                "justificativa": `${this.sacsolicitacao.parecer}`,
                "respondido_por":2,
                "id_status_leitura": 1,
                "dt_resposta": now().toString
                //"status": `${[this.statuss.filter(a => a.id_status == this.sacsolicitacao.id_status).map(a => a.status)]}`        
        };

        const url = `${baseApiUrl}/sac/solicitacoes/save/resposta`   

            axios.post(url,corpo).then(() => {
                    //this.$toasted.global.defaultSuccess()
                    this.loadSacSolicitacoesTratativas()
                    //this.postNotificacao()
                    //this.reset() limpar os objetos valores
                })
                .catch(showError)
        },


        

        reset() {            
            this.parecer = ''
            this.sacsolicitacao.parecer = ''
        },

        putSacTratativa() {                        
          let corpo = { 
               "id_solicitacao": `${this.sacsolicitacao.id_solicitacao}`,               
          };
          const url = `${baseApiUrl}/sac/solicitacoes/put/resposta`   

              axios.post(url,corpo).then(() => {
                      //this.$toasted.global.defaultSuccess()
                      //this.loadSacSolicitacoesTratativas()
                      //this.reset()  //limpar os objetos valores
                  })
                  .catch(showError)
        },

        postNotificacao() {                        
          let corpo = {                
                "id_funcionario": `${this.sacsolicitacao.id_funcionario_solicitante}`,
                "message": 'Existe uma nova tratativa para sua solicitação nº '+`${this.sacsolicitacao.id_solicitacao}`,                
                "dt_notificacao": now().toString ,
                "type": 1,
                        
        };

        const url = `${baseApiUrl}/sac/solicitacoes/notificacoes`   

            axios.post(url,corpo).then(() => {
                    //this.$toasted.global.defaultSuccess()
                   // this.loadSacSolicitacoesTratativas()
                    //this.reset() limpar os objetos valores
                })
                .catch(showError)
        },

        



    limparFiltro(){
      this.search= ""
    },
  
  },  


  created(){
    this.loadPermissao()     
  },



  mounted() {  
    /*
        this.loadEmpresas()                                        
        this.loadGaragens()          
        this.loadStatus()        
        this.loadSacSolicitacoes()     
        this.loadCarregaSac() 
        this.loadCarregaSacT()
        this.temporizador()
        this.loadSacSolicitacoesTratativas()
    */
    },
  }
</script>


<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

</style>